import { ICellRendererParams } from 'ag-grid-community';
import { ClaimRow } from 'api/endpoints';
import { useAppDispatch } from 'hooks/reducerHooks';
import { setSection as setClaimsSection } from 'reducer/claimsReducer';
import { setSection as setContractsSection } from 'reducer/contractsReducer';
import { useClaimToolQueryParams } from 'utils/hooks/useClaimToolQueryParams';
import { SectionType } from '../types';
import { ConterpartyLink } from './CounterpartyNameCell';
import './ClaimCounterpartyNameCell.css';

type CounterpartyNameCellProps = ICellRendererParams<ClaimRow, string> & {
  section: SectionType;
};

export const ClaimCounterpartyNameCell = (props: CounterpartyNameCellProps) => {
  const claim = props.data as ClaimRow;
  const { buildCounterpartyPath } = useClaimToolQueryParams();
  const dispatch = useAppDispatch();

  const handleCounterpartyClick = () => {
    //todo: do we really need these two dispatch???
    dispatch(setClaimsSection(SectionType.Claims));
    dispatch(setContractsSection(undefined));
  };

  if (props.section === SectionType.Matching) return claim.counterpartyName;

  if (claim.matchCode)
    return (
      <ConterpartyLink
        text={claim.counterpartyName}
        to={buildCounterpartyPath(claim.matchCode)}
        onClick={handleCounterpartyClick}
      />
    );

  return <span className='claim-counterparty-cell__name'>{claim.counterpartyName}</span>
};
